import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../CSS/Footer.css';

const Footer = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleAdminClick = () => {
    navigate('/admin/login');
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      timeZone: 'Asia/Colombo',
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      timeZone: 'Asia/Colombo',
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Time Section */}
        <div className="time-section">
          <div className="current-time">
            {formatTime(currentTime)}
          </div>
          <div className="current-date">
            {formatDate(currentTime)} - Local Time Srilanka(GMT+5:30)
          </div>
        </div>
        {/* Copyright Section */}
        <div className="copyright-section">
          <div className="copyright">
            © {new Date().getFullYear()} All rights reserved
          </div>
          <div className="made-by">
            Made by <span className="highlight" onClick={handleAdminClick} style={{cursor: 'pointer'}}>Udana</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;